<template lang="html">
	<div id="page__storage" class="center-panel">
		<md-content md-theme="white" v-bind:loading="progress">
			<StoragesMenu></StoragesMenu>
			<sort-table
				v-bind:columns="tableColumns" v-model="prices" v-on:refresh="getPrices" v-bind:per-page="perPage" 
				v-bind:total="pricesAmount" link table-id="storagesprice" ref="table" v-on:create="addPrice" tableHeight="calc(100% - 48px)"
			>
				<template slot="stock_id" slot-scope="scope">
					<span>{{ scope.item.stock && scope.item.stock.name ? scope.item.stock.name  : 'Не установлен' }}</span>
                </template>
				<template slot="actions" slot-scope="scope">
                    <z-icon-button v-bind:icon="['fa', 'trash']" v-on:click.stop.prevent="onRemove(scope.item.id)" danger-light rounded></z-icon-button>
                </template>
			</sort-table>
		</md-content>
	</div>
</template>
<script>
	import StoragesMenu from './StoragesMenu.vue';
	import SortTable   from '@/components/SortTable';
	import ZIconButton from '@/components/ZIconButton.vue';
	export default {
		components: { SortTable, ZIconButton, StoragesMenu },
		data() {
			return {
				title: 'Сверхнормативное хранение',
				perPage: 50,
				tableColumns: [
					{ label: 'ID',  field: 'id',   default: true, sortable: true },
					{ label: 'Тип', field: 'type_name', sortable: true },
					{ label: 'Склад', field: 'stock_id', sortable: true },
					{ label: 'Минимальный',     field: 'is_min_name', sortable: false},
					{ label: 'Бесплатный париод (д)',  field: 'free_time',    sortable: true },
					{ label: 'Цена (руб.)',     field: 'price',       sortable: true },
					{ label: 'Вес/Объём мин.',  field: 'value_min',   sortable: true },
					{ label: 'Вес/Объём макс.', field: 'value_max',   sortable: true },
					{ label: '', field: 'actions' }
				],
			}
		},
		computed: {
			/**
             * Флаг загрузки текущего компонента
             */
            progress() {
                return this.progressObj['get-storageprice-list'];
            },
            /**
             * Объект с флагами загрузки
             */
            progressObj() {
                return this.$store.state.progressObj;
            },
			/**
			 * Список городов
			 */
			prices() {
				return this.$store.state.cost.storage_prices.map(price => {
					price.routerLink  = {name: 'StoragePrice', params: {id: price.id}, query: this.$route.query};
                    price.type_name   = parseInt(price.type) === 1 ? 'По весу' : parseInt(price.type) == 2 ? 'По объёму' : 'Не определено'
					price.is_min_name = parseInt(price.is_min) === 1 ? 'Да' : 'Нет'
					return price;
				});
			},
			/**
			 * Количество городов
			 */
			pricesAmount() {
				return this.$store.state.cost.storage_prices_amount
			}
		},
		created() {
			this.$store.commit('setTitle', this.title)
		},
		methods: {
			/**
			 * Добавление города
			 */
			addPrice() {
				this.$router.push({ name: 'StoragePrice', params: {id: 'new'} });
			},
			/**
			 * Получение городов
			 */
			getPrices(page, count, orderBy, orderType, filter) {
				this.$store.commit('showProgressBar', 'get-storageprice-list');
				return this.$store.dispatch('cost/getStoragePrices', {
					page: page, 
					order_by:   orderBy, 
					order_type: orderType, 
					count: count,
					filter: this.resolveQueryFilter()
				}).finally(() => this.$store.commit('hideProgressBar', 'get-storageprice-list'));
			},
			/**
			 * Фильтрация
			 */
			resolveQueryFilter() {
				if (!this.$route.query || !this.$route.query.filter) return null;
				let filter = Object.assign({}, JSON.parse(this.$route.query.filter)), model = [], result = {model: [], relation: [], condition: 'and'};

                if (filter.type)     model.push(['type', '=', filter.type]);
				if (filter.stock_id) model.push(['stock_id', '=', filter.stock_id]);

                model.map((item, i) => {
                    result.model.push(item);
                    if (model[i+1]) result.model.push('and');
                });

				return result;
			},
			/**
			 * Удаление города
			 */
			removePrice(id) {
				if (!id) return;
				this.$store.commit('showProgressBar', 'get-storageprice-list');
				this.$store.dispatch('cost/deleteStoragePrice', id)
					.then(() => this.$root.$emit('refresh-table', 'storagesprice'))
					.finally(() => this.$store.commit('hideProgressBar', 'get-storageprice-list'));
			},
			/**
			 * Модальное окно с подтверждением удаления города
			 */
			onRemove(id) {
                this.$root.$emit(
                    'z-alert', 'Вы уверены в удалении цены?', 'Действие необратимо!',
                    () => this.removePrice(id)
                );
            },
		},
	}
</script>


// WEBPACK FOOTER //
// Storages.vue?0d1caf66